<div class="container" [ngSwitch]="mode">

    <div *ngSwitchDefault>
      <div *ngIf="isLoading" class="spinner">
        <mat-spinner></mat-spinner>
      </div>
      <table *ngIf="!isLoading" style="width:100%">
        <tr  class="back">
          <th>S/N</th>
          <th>Name</th>
          <th>
            <button class="add" mat-raised-button color="basic" (click)="addNew()">
              Add New
            </button>
          </th>
        </tr>
        <tr class="td" *ngFor="let title of titles">
          <td>{{title.id}}</td>
          <td>{{title.name}}</td>
          <td>
            <button mat-raised-button color="primary" (click)=" edit(title)">
              Edit
            </button>
            <button mat-raised-button color="primary" style="margin-left: 5px;" (click)="delete(title)">
              Delete
            </button>
          </td>
        </tr>
      </table>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
            <p>{{Errors}}</p>
        </div>
      </div>
      <div class="last">
      </div>
    </div>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'add'">
      <div class="post">
        <div class="title">Create Nation</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input formControlName="name" matInput placeholder="Imo">
              </mat-form-field>
          </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div>
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    <form [formGroup]="stateForm" (ngSubmit)="onSubmit($event)" class="post" *ngSwitchCase="'edit'">
      <div class="post">
        <div class="title">Edit Nation</div>
        <div class="form">
          <span class="input">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input formControlName="name" matInput placeholder="Imo">
              </mat-form-field>
          </span>
        </div>
        <div class="errorMessage">
          <div *ngIf="Errors" class="error">
              <p>{{Errors}}</p>
          </div>
        </div>
        <div class="errorMessage">
          <div *ngIf="Success" class="Success">
              <p>Saved Succesfully</p>
          </div> 
        </div>
        <div class="but">
          <button class="create" mat-raised-button color="primary">
            {{ isLoading? "Saving...": "Save"}}
          </button>
        </div>
      </div>
    </form>
    
     
    </div>